import { createRoot } from 'react-dom/client';
import { SearchEmbedMain } from './components';

document.querySelectorAll('[data-check-salary-render="search-embed"]').forEach((element) => {
  const root = createRoot(element);
  const searchFormId = element.getAttribute('data-search-form-id');
  const areaOfExpertiseId = element.getAttribute('data-area-of-expertise-id');

  root.render(
    <SearchEmbedMain
      searchFormId={searchFormId}
      areaOfExpertiseId={areaOfExpertiseId}
    />,
  );
});
